import React, { useState, useEffect } from 'react';
import './PCI.css'; // Importando o arquivo de estilos CSS
import Joyride from 'react-joyride';
import Swal from 'sweetalert2';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';
import { 
  MdMenu, 
  MdBolt, 
  MdBook, 
  MdArrowForward, 
  MdArrowBack,
  MdGroups, // Para público-alvo
  MdErrorOutline, // Para problema
  MdLightbulb, // Para solução
  MdStars, // Para benefício
  MdQuestionMark, // Para objeção
  MdDashboard,
  MdEventAvailable,
  MdFace,
  MdForum,
  MdSettings,
  MdLocalActivity,
  MdAutorenew,
  MdKeyboardArrowLeft
} from "react-icons/md";
import { RiCopperCoinLine } from "react-icons/ri";
import { FaRobot } from "react-icons/fa";
import { ChakraProvider, useMediaQuery, Progress } from "@chakra-ui/react";
import CustomDrawer from './CustomDrawer';
import translations from '../utils/translations.json';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Pagination } from 'swiper/core';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import ReactMarkdown from 'react-markdown';



SwiperCore.use([Navigation, Pagination]);

const isValidUrl = (url) => {
  try {
    new URL(url);
  } catch (e) {
    return false;
  }
  return true;
};

const UserProfileImage = ({ userId, perfilPicture }) => {
  const defaultAvatarUrl = `${process.env.REACT_APP_AVATAR_BASE_URL}${userId}${process.env.REACT_APP_AVATAR_PARAMS}`;
  const imageUrl = isValidUrl(perfilPicture) ? perfilPicture : defaultAvatarUrl;
  return (
    <div className="user-profile-image" style={{ backgroundImage: `url(${imageUrl})` }}></div>
  );
};

const UserInfo = ({ userName, userId, userCredits }) => {
  
  const [isMobile] = useMediaQuery('(max-width: 768px)');

  const handleClick = () => {
    window.open('/viewuser', '_self');
  };
  return (
    <div className="user-info" onClick={handleClick}  style={{
      position: 'absolute',
      top: '1px',
      right: '20px',
      padding: isMobile ? '5px 14px' : '8px 16px',
      backgroundColor: '#f8fafc',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
      color: '#fff',
      fontSize: '17px',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      border: '1px solid #e2e8f0',
      borderRadius: '80px',
      gap: isMobile ? '0px' : '12px'
  }}
>
      <UserProfileImage userId={userId} perfilPicture={localStorage.getItem('perfil_picture')} />
      <div className="user-credits" style={{ color: '#4a5568', fontWeight: '500' }}>
        {userName} | {userCredits} {t('pci', 'credits')}
      </div>
      <div className="userInfoMobile" style={{ color: '#4a5568', fontWeight: '500' }}>
        {userCredits} {t('pci', 'credits')}
      </div>
    </div>
  );
};

let t;

const PCI = () => {
  const [summary, setSummary] = useState('');
  const userId = localStorage.getItem('userId');
  const userName = localStorage.getItem('username');

  const [totenId, setTotenId] = useState(localStorage.getItem('totenId'));
  const [response, setResponse] = useState('');
  const perfilPicture = localStorage.getItem('perfil_picture')
  const defaultImageUrl = "https://blob01instasuccess.blob.core.windows.net/fotos-logos/icone-04.png";
  const navigate = useNavigate();
  const location = useLocation();

  // Detectar se veio do GrowthPilot
  const params = new URLSearchParams(location.search);
  const fromGrowthPilot = params.get('from') === 'growthpilot';

  const [formData, setFormData] = useState({
    targetAudience: '',
    problem: '',
    solution: '',
    benefit: '',
    objection: ''
  });

  const [initialFormData, setInitialFormData] = useState({
    targetAudience: '',
    problem: '',
    solution: '',
    benefit: '',
    objection: ''
  });

  const [language, setLanguage] = useState(localStorage.getItem('language') || 'pt');

  t = (screen, key) => translations[language][screen][key];

  const [isOpen, setIsOpen] = useState(false);
  const [isLoadingPCI, setIsLoadingPCI] = useState(false);
  const [swiperRef, setSwiperRef] = useState(null);

  const [currentStep, setCurrentStep] = useState(0);
  const [progress, setProgress] = useState(0);
  
  const steps = [
    {
      field: 'targetAudience',
      title: t('pci', 'targetAudience'),
      placeholder: t('pci', 'audiencePlaceholder'),
      icon: <MdGroups size={24} />
    },
    {
      field: 'problem',
      title: t('pci', 'problem'),
      placeholder: t('pci', 'problemPlaceholder'),
      icon: <MdErrorOutline size={24} />
    },
    {
      field: 'solution',
      title: t('pci', 'solution'),
      placeholder: t('pci', 'solutionPlaceholder'),
      icon: <MdLightbulb size={24} />
    },
    {
      field: 'benefit',
      title: t('pci', 'benefit'),
      placeholder: t('pci', 'benefitPlaceholder'),
      icon: <MdStars size={24} />
    },
    {
      field: 'objection',
      title: t('pci', 'objection'),
      placeholder: t('pci', 'objectionPlaceholder'),
      icon: <MdQuestionMark size={24} />
    }
  ];

  useEffect(() => {
    setProgress((currentStep / (steps.length - 1)) * 100);
  }, [currentStep]);

  const handleNext = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep(currentStep + 1);
    }
  };

  const handleBack = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  const handleHamburguerClick = () => {
    setIsOpen(true); // Abre o Drawer
  };

  const handleCloseDrawer = () => {
    setIsOpen(false); // Fecha o Drawer
  };

  const mainOpen = (language) => {
    if (fromGrowthPilot) {
      navigate(`/growthpilot?lang=${language}`);
    } else {
      navigate(`/main?lang=${language}`);
    }
  }

  const perfilOpen = () => {
    if (fromGrowthPilot) {
      navigate(`/growthpilot?lang=${language}`);
    } else {
      navigate(`/viewuser?lang=${language}`);
    }
  }

  const analysisOpen = () => {
    if (fromGrowthPilot) {
      navigate(`/growthpilot?lang=${language}`);
    } else {
      navigate(`/analysis?lang=${language}`);
    }
  }

  const historyOpen = (language) => {
    if (fromGrowthPilot) {
      navigate(`/growthpilot?lang=${language}`);
    } else {
      navigate(`/history?lang=${language}`);
    }
  }

  const automacaoOpen = (language) => {
    if (fromGrowthPilot) {
      navigate(`/automacao?lang=${language}&from=growthpilot`);
    } else {
      navigate(`/automacao?lang=${language}`);
    }
  }

  const logout = (language) => {
    navigate(`/login?lang=${language}`);
  }

  const getCreditsSum = () => {
    const creditsString = localStorage.getItem('credits');
    const credits = creditsString ? JSON.parse(creditsString) : { "GPT-3": 0, "GPT-4": 0 };
    return (credits["GPT-3"] || 0) + (credits["GPT-4"] || 0);
  };

  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === 'language') {
        setLanguage(localStorage.getItem('language') || 'pt');
      }
    };
    window.addEventListener('storage', handleStorageChange);
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  const [runJoyride, setRunJoyride] = useState(false);
  const [joyrideSteps, setJoyrideSteps] = useState([
    {
      target: '.target-audience',
      content: t('pci', 'joyrideSteps')[0].content,
    },
    {
      target: '.problem',
      content: t('pci', 'joyrideSteps')[1].content,
    },
    {
      target: '.solution',
      content: t('pci', 'joyrideSteps')[2].content,
    },
    {
      target: '.benefit',
      content: t('pci', 'joyrideSteps')[3].content,
    },
    {
      target: '.objection',
      content: t('pci', 'joyrideSteps')[4].content,
    },
    {
      target: '.btnaction',
      content: t('pci', 'joyrideSteps')[5].content,
    }
  ]);

  useEffect(() => {
    if (localStorage.getItem('firstAccess') === 'true') {
      setRunJoyride(true);
    }
  }, []);

  async function confirmSubmit() {
    // Validação dos campos
    if (!formData.targetAudience || !formData.problem || !formData.solution || !formData.benefit || !formData.objection) {
      Swal.fire({
        icon: 'warning',
        title: t('pci', 'fillAllFieldsWarning'),
        text: t('pci', 'fillAllFieldsText'),
        customClass: {
          popup: 'my-swal-special',
          title: 'myCustomTitle'
        }
      });
      return;
    }

    // Buscar dados atualizados do banco de dados sem atualizar o estado do formulário
    let updatedData;

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/pciControl/fetch`, {
        userId,
        totenId,
        perfil_picture: ''
      });

      if (response.status !== 200) {
        throw new Error(t('pci', 'fetchDataError'));
      }

      updatedData = response.data.pciData;

    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: t('pci', 'errorTitle'),
        text: error.message,
        customClass: {
          popup: 'my-swal-special',
          title: 'myCustomTitle'
        }
      });
      return;
    }

    const normalizedFormData = normalizeAndSortObject(formData);
    const normalizedUpdatedData = updatedData ? normalizeAndSortObject({
      targetAudience: updatedData.targetAudience,
      problem: updatedData.problem,
      solution: updatedData.solution,
      benefit: updatedData.benefit,
      objection: updatedData.objection
    }) : normalizeAndSortObject({
      targetAudience: '',
      problem: '',
      solution: '',
      benefit: '',
      objection: ''
    });

    // Verifica se os dados do formulário foram alterados
    if (JSON.stringify(normalizedFormData) === JSON.stringify(normalizedUpdatedData)) {
      // Os dados não foram alterados, usa os dados do banco de dados
      setResponse(updatedData.pci);
      setSummary(updatedData.brief_pci);

      setTimeout(() => {
        if (swiperRef) {
          swiperRef.slideNext(1000);
        }
      }, 100);
    } else {
      const userChoice = localStorage.getItem('popupChoicePCI');

      if (userChoice === 'checked') {
        handleDataSubmission();
      } else {
        Swal.fire({
          icon: 'warning',
          title: t('pci', 'confirmCreditUsage'),
          showCancelButton: true,
          confirmButtonText: t('pci', 'yes'),
          cancelButtonText: t('pci', 'no'),
          text: t('pci', 'Explanation'),
          input: 'checkbox',
          inputValue: 0,
          inputPlaceholder: t('pci', 'doNotShowAgain'),
          customClass: {
            popup: 'my-swal-special',
            title: 'myCustomTitle'
          }
        }).then((result) => {
          if (result.isConfirmed) {
            if (result.value === 1) {
              localStorage.setItem('popupChoicePCI', 'checked');
            }
            handleDataSubmission();
          }
        });
      }
    }
  }

  const [userCredits, setUserCredits] = useState(getCreditsSum());

  const fetchPCI = async () => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/pciControl/fetch`, {
        userId: userId,
        totenId: totenId,
        perfil_picture: `${process.env.REACT_APP_AVATAR_BASE_URL}${userId}${process.env.REACT_APP_AVATAR_PARAMS}`
      });

      if (response.status !== 200) {
        throw new Error(t('pci', 'fetchDataError'));
      }

      const pciData = response.data.pciData;

      setTotenId(response.data.totenId);
      localStorage.setItem('totenId', response.data.totenId);

      if (pciData) {
        setFormData({
          targetAudience: pciData.targetAudience,
          problem: pciData.problem,
          solution: pciData.solution,
          benefit: pciData.benefit,
          objection: pciData.objection
        });
        setInitialFormData({
          targetAudience: pciData.targetAudience,
          problem: pciData.problem,
          solution: pciData.solution,
          benefit: pciData.benefit,
          objection: pciData.objection
        });
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: t('pci', 'errorTitle'),
        text: error.message,
        customClass: {
          popup: 'my-swal-special',
          title: 'myCustomTitle'
        }
      });
    }
  };

  let fetchCalled = 0;

  useEffect(() => {
    if (fetchCalled === 0) {
      fetchPCI();
      fetchCalled++;
    }
  }, [userId, totenId]);

 

  const handleInputChange = (e, fieldType) => {
    const value = e.target.value;
    setFormData({ ...formData, [fieldType]: value });
  };

  const handleSummaryClick = async () => {
    try {
      Swal.fire({
        title: t('pci', 'loadingSummary'),
        text: t('pci', 'waitLoadingSummary'),
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
        customClass: {
          popup: 'my-swal-special',
          title: 'myCustomTitle'
        }
      });

      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/pciControl/summary`, {
        userId,
        totenId
      });

      if (response.status !== 200) {
        throw new Error(t('pci', 'summaryFetchError'));
      }

      let summary = response.data.summary;

      setSummary(summary);

      Swal.close();

      const finalSummary = summary || t('pci', 'summaryNotAvailable');

      const { value: editedSummary } = await Swal.fire({
        title: t('pci', 'summary'),
        input: "textarea",
        inputValue: finalSummary,
        inputPlaceholder: t('pci', 'summaryPlaceholder'),
        showCancelButton: true,
        confirmButtonText: t('pci', 'saveSummary'),
        cancelButtonText: t('pci', 'cancel'),
        customClass: {
          popup: 'my-swal-special',
          title: 'myCustomTitle'
        },
        didOpen: () => {
          const textarea = Swal.getPopup().querySelector('textarea');
          if (textarea) {
            textarea.selectionStart = 0;
            textarea.selectionEnd = 0;
            textarea.focus();
            textarea.scrollTop = 0;
          }
        }
      });

      if (editedSummary && editedSummary !== finalSummary) {
        setSummary(editedSummary);

        await axios.post(`${process.env.REACT_APP_API_BASE_URL}/pciControl/updateSummary`, {
          userId,
          totenId,
          summary: editedSummary
        });

        Swal.fire({
          icon: 'success',
          title: t('pci', 'summarySaved'),
          customClass: {
            popup: 'my-swal-special',
            title: 'myCustomTitle'
          }
        });
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: t('pci', 'errorTitle'),
        text: error.message,
        customClass: {
          popup: 'my-swal-special',
          title: 'myCustomTitle'
        }
      });
    }
  };

  const normalizeAndSortObject = (obj) => {
    const sortedObj = {};
    const keys = Object.keys(obj).sort();
    keys.forEach((key) => {
      sortedObj[key] = typeof obj[key] === 'string' ? obj[key].replace(/\s+/g, '').toLowerCase() : obj[key];
    });
    return sortedObj;
  };

  async function handleDataSubmission() {
    try {
      let firstAccess = false;

      if (localStorage.getItem('firstAccess') !== 'undefined' && localStorage.getItem('firstAccess') === 'true') {
        firstAccess = true;
      }

      const userCredits = JSON.parse(localStorage.getItem('credits')) || { "GPT-3": 0, "GPT-4": 0 };

      if (userCredits["GPT-4"] < 2) {
        Swal.fire({
          icon: 'warning',
          title: t('pci', 'insufficientCreditsWarning'),
          text: t('pci', 'insufficientCreditsText'),
          customClass: {
            popup: 'my-swal-special',
            title: 'myCustomTitle'
          }
        });
        swiperRef.slideTo(0, 1000);
        return;
      }

      setIsLoadingPCI(true);
      setTimeout(() => {
        if (swiperRef) {
          swiperRef.slideNext(1000);
        }
      }, 100);

      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/pciControl`, {
        userId,
        totenId,
        targetAudience: formData.targetAudience,
        problem: formData.problem,
        solution: formData.solution,
        benefit: formData.benefit,
        objection: formData.objection,
        language: language
      });

      if (response.status !== 200) {
        throw new Error(t('pci', 'summaryFetchError'));
      } else {
        if (firstAccess) {
          setTimeout(() => {
            Swal.fire({
              title: t('pci', 'readyToCreateTitle'),
              text: t('pci', 'readyToCreateText'),
              icon: 'info',
              showCancelButton: true,
              confirmButtonText: t('pci', 'createNowButton'),
              cancelButtonText: t('pci', 'readPciButton'),
              customClass: {
                popup: 'my-swal-special',
                title: 'myCustomTitle'
              }
            }).then((result) => {
              if (result.isConfirmed) {
                mainOpen(localStorage.getItem('language'));
              }
            });
          }, 15000);
        }
      }

      const result = response.data;
      setResponse(result.data);

      const newCredits = result.credits;
      localStorage.setItem('credits', JSON.stringify(newCredits));
      setUserCredits(getCreditsSum());
      setIsLoadingPCI(false);
    } catch (error) {
      setIsLoadingPCI(false);
      Swal.fire({
        icon: 'error',
        title: t('pci', 'errorTitle'),
        text: error.response.data.error,
        customClass: {
          popup: 'my-swal-special',
          title: 'myCustomTitle'
        }
      });
    }
  }

  const customStyles = {
    options: {
      arrowColor: '#8E59FF',
      backgroundColor: '#FFFFFF',
      primaryColor: '#8E59FF',
      textColor: '#757575',
      zIndex: 1000,
    },
    buttonNext: {
      backgroundColor: '#8E59FF'
    },
    buttonBack: {
      backgroundColor: '#CCCCCC',
      color: '#FFFFFF'
    },
    buttonSkip: {
      backgroundColor: '#CCCCCC',
      color: '#FFFFFF'
    }
  };

  const renderCard = () => {
    const currentField = steps[currentStep];
    return (
      <div className="pci-card">
        <div className="pci-card-icon">{currentField.icon}</div>
        <h2 className="pci-card-title">{currentField.title}</h2>
        <input
          type="text"
          className="pci-card-input"
          value={formData[currentField.field]}
          onChange={(e) => handleInputChange(e, currentField.field)}
          placeholder={currentField.placeholder}
        />
        <div className="pci-card-navigation">
          <button 
            className={`nav-button ${currentStep === 0 ? 'disabled' : ''}`}
            onClick={handleBack}
            disabled={currentStep === 0}
          >
            <MdArrowBack />
          </button>
          {currentStep === steps.length - 1 ? (
            <button
              className="googleButtonNew"
              onClick={confirmSubmit}
              disabled={!formData[currentField.field]}
            >
              <MdBolt className="buttonIcon" size={24} /> {t('pci', 'sendData')}
            </button>
          ) : (
            <button
              className="nav-button"
              onClick={handleNext}
              disabled={!formData[currentField.field]}
            >
              <MdArrowForward />
            </button>
          )}
        </div>
      </div>
    );
  };

  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [isMobile] = useMediaQuery('(max-width: 768px)');

  // Sidebar igual ao GrowthPilot
  const renderSidebar = () => {
    if (!fromGrowthPilot) return null;
    return (
      <div className={`sidebar-fixed ${isMobile && isSidebarOpen ? 'active' : ''} ${isSidebarCollapsed ? 'collapsed' : ''}`}>
        <div className="sidebar-header">
          <div className="sidebar-logo">
            <FaRobot size={22} />
            <span className="menu-text">GrowthPilot</span>
          </div>
          <div className="sidebar-toggle-btn" onClick={() => setIsSidebarCollapsed(prev => !prev)}>
            <MdKeyboardArrowLeft size={24} />
          </div>
        </div>
        <div className="sidebar-menu">
          <div className="menu-item" onClick={() => navigate(`/growthpilot?lang=${language}`)}>
            <MdEventAvailable size={20} />
            <span className="menu-text">Content Planner</span>
          </div>
          <div className="menu-item active">
            <RiCopperCoinLine size={20} />
            <span className="menu-text">PCI</span>
          </div>
          <div className="menu-item" onClick={() => navigate(`/viewuser?lang=${language}${fromGrowthPilot ? '&from=growthpilot' : ''}`)}>
            <MdFace size={20} />
            <span className="menu-text">Avatares</span>
          </div>
         {/* <div className="menu-item" onClick={() => navigate(`/history?lang=${language}${fromGrowthPilot ? '&from=growthpilot' : ''}`)}>
            <MdForum size={20} />
            <span className="menu-text">Histórico de Conteúdo</span>
          </div> */}
          <div className="menu-item" onClick={() => automacaoOpen(language)}>
            <MdAutorenew size={20} />
            <span className="menu-text">Automação</span>
          </div>

          <div className="menu-item" onClick={() => navigate(`/growthpilot/analytics?lang=${language}`)}>
            <MdDashboard size={20} />
            <span className="menu-text">Analytics</span>
          </div>

          <div className="menu-item" onClick={() => navigate(`/growthpilot/config?lang=${language}`)}>
            <MdSettings size={20} />
            <span className="menu-text">Configurações</span>
          </div>
         
          <div className="menu-item" onClick={() => navigate(`/main?lang=${language}`)}>
            <MdArrowBack size={20} />
            <span className="menu-text">Voltar para o PostSucesso</span>
          </div>
        </div>
        <div className="sidebar-footer">
          <div className="support-button">
            <MdLocalActivity size={22} />
            <span className="menu-text">Suporte</span>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {renderSidebar()}
      <div className={`pci-main-content${fromGrowthPilot ? ' growthpilot-font' : ''}${isSidebarCollapsed ? ' sidebar-collapsed' : ''}`}>
        <Joyride
          run={runJoyride}
          steps={joyrideSteps}
          styles={customStyles}
          continuous={true}
          showSkipButton={true}
          locale={{
            skip: t('pci', 'joyrideLabelsSkip'), next: t('pci', 'joyrideLabelsNext'),
            back: t('pci', 'joyrideLabelsBack'), last: t('pci', 'joyrideLabelsLast')
          }}
          callback={(data) => {
            if (data.status === 'finished' || data.status === 'skipped') {
              setRunJoyride(false);
            }
          }}
        />
        <Swiper
          onSwiper={(swiper) => setSwiperRef(swiper)}
          onSlideChange={(swiper) => { }}
          navigation
          pagination={{ clickable: true }}
          className="mySwiper pci-swiper"
          slidesPerView={1}
          style={{
            "--swiper-navigation-color": "#fff",
            "--swiper-pagination-color": "#fff",
            "--swiper-navigation-size": "20px"
          }}
        >
          <SwiperSlide>
            <div className={`pci-container ${fromGrowthPilot ? 'growthpilot-mode' : ''}`}>
              <ChakraProvider>
                <CustomDrawer
                  isOpen={isOpen}
                  onClose={handleCloseDrawer}
                  onContentOpen={() => mainOpen(language)}
                  onPerfilOpen={() => perfilOpen(language)}
                  onAnalysisOpen={() => analysisOpen(language)}
                  onLogout={() => logout(language)}
                  onHistoryOpen={() => historyOpen(language)}
                  onAutomacaoOpen={() => automacaoOpen(language)}
                  t={t}
                  language={language}
                  setLanguage={setLanguage}
                />
              </ChakraProvider>
              <div className={`header ${fromGrowthPilot ? 'growthpilot-mode' : ''}`}>
                {fromGrowthPilot ? (
                  // Header do GrowthPilot
                  <div className="growthpilot-topbar">
                    <div className="growthpilot-title-container">
                      <div className="growthpilot-title">
                        <MdDashboard size={24} className="title-icon" />
                        GrowthPilot
                      </div>
                    </div>
                    <div className="topbar-actions">
                      <div className="growthpilot-user growthpilot-user-large">
                        <UserProfileImage userId={userId} perfilPicture={perfilPicture} />
                      </div>
                    </div>
                  </div>
                ) : (
                  // Header original do PostSucesso
                  <>
                    <UserInfo userName={userName} userId={userId} userCredits={userCredits} />
                    <div className="image-container_pci">
                      <MdMenu
                        className="menu-icon"
                        onClick={handleHamburguerClick}
                      />
                    </div>
                    <div className="image-container_pci_02">
                      <img
                        src="https://blob01instasuccess.blob.core.windows.net/fotos-logos/postSucessoLogo.png"
                        alt="Logo"
                        className="logo"
                      />
                    </div>
                  </>
                )}
              </div>

              <div className="pci-content">
                <div className="pci-progress">
                  <Progress value={progress} size="sm" colorScheme="purple" />
                  <div className="progress-steps">
                    {steps.map((step, index) => (
                      <div
                        key={index}
                        className={`progress-step ${index === currentStep ? 'active' : ''} ${index < currentStep ? 'completed' : ''}`}
                        onClick={() => formData[steps[currentStep].field] && setCurrentStep(index)}
                      >
                        {step.icon}
                      </div>
                    ))}
                  </div>
                </div>
                {renderCard()}
              </div>
            </div>
          </SwiperSlide>
          {isLoadingPCI ? (
            <SwiperSlide className="blink">{t('pci', 'loadingProfile')}</SwiperSlide>
          ) : (
            response.length > 0 && (
              <SwiperSlide>
                <div className={`header ${fromGrowthPilot ? 'growthpilot-mode' : ''}`}>
                  {fromGrowthPilot ? (
                    // Header do GrowthPilot
                    <div className="growthpilot-topbar">
                      <div className="growthpilot-title-container">
                        <div className="growthpilot-title">
                          <MdDashboard size={24} className="title-icon" />
                          GrowthPilot
                        </div>
                      </div>
                      <div className="topbar-actions">
                        <div className="growthpilot-user growthpilot-user-large">
                          <UserProfileImage userId={userId} perfilPicture={perfilPicture} />
                        </div>
                      </div>
                    </div>
                  ) : (
                    // Header original do PostSucesso
                    <>
                      <UserInfo userName={userName} userId={userId} userCredits={userCredits} />
                      <div className="image-container_pci">
                        <MdMenu
                          className="menu-icon"
                          onClick={handleHamburguerClick}
                        />
                      </div>
                      <div className="image-container_pci_02">
                        <img
                          src="https://blob01instasuccess.blob.core.windows.net/fotos-logos/postSucessoLogo.png"
                          alt="Logo"
                          className="logo"
                        />
                      </div>
                    </>
                  )}
                </div>
                <div className={`divTextAreaPCI ${fromGrowthPilot ? 'growthpilot-mode' : ''}`}>
                  <ReactMarkdown className="markdownSpace custom-markdown" children={response} />
                  <div className="buttonGroupPCI">
                    <button className="googleButtonNew" onClick={handleSummaryClick}> <MdBook className="buttonIcon" /> <span className="buttonContent" >{t('pci', 'summary')}</span></button>
                  </div>
                </div>
              </SwiperSlide>
            )
          )}
        </Swiper>
      </div>
    </>
  );
};

export default PCI;